module.exports = __webpack_public_path__ + "static/media/bridge.3e3d8150.png";